<template>
  <div class="yang-font-selector">
    <span class="font-label" :style="{
      width: titleWidth+ 'px'
     }">{{$t('components_my_font_family_index_2307')}}</span>
    <el-select
      v-model="font"
      ref="selector"
      popper-class="font-family-popper"
      size="small"
      style="width: 200px;"
      @change="onSelectFont">
      <div class="lang-group">
        <span :class="['lang-item',lang==='en'?'lang-item-active':'']" @click="onClickLanguage('en')">{{$t('components_my_font_family_index_2308')}}</span>
        <span :class="['lang-item',lang==='zh'?'lang-item-active':'']" @click="onClickLanguage('zh')">{{$t('base_options_config_1862')}}</span>
      </div>
      <div class="lang-group-placeholder"></div>
      <el-option-group
        v-if="fontFamilyHistory.length"
        :label="$t('components_my_color_picker_index_2300')">
        <el-option
          v-for="item in fontFamilyHistory"
          :key="item.value+'-history'"
          :label="item.label"
          :value="item.value"
          :title="item.label">
          <svg v-if="$store.state.options.fontFamilySystem[item.value]" class="font_svg"><use :xlink:href="$store.state.options.fontFamilySystem[item.value]"></use></svg>
          <span v-else :class="item.label" v-text="item.label"></span>
        </el-option>
      </el-option-group>
      <el-option-group
        :label="$t('components_my_font_family_index_2309')">
        <el-option
          v-for="item in fontFamilySystem"
          :key="item.value"
          :label="item.label"
          :value="item.value"
          :title="item.label">
          <svg v-if="$store.state.options.fontFamilySystem[item.value]" class="font_svg"><use :xlink:href="$store.state.options.fontFamilySystem[item.value]"></use></svg>
        </el-option>
      </el-option-group>
      <el-option-group
        :label="$t('components_my_font_family_index_2310')">
        <el-option
          v-for="item in fontFamilyFree"
          :key="item.value"
          :label="item.label"
          :value="item.value"
          :title="item.label">
          <span :class="item.label" v-text="item.label"></span>
        </el-option>
      </el-option-group>
      <el-option style="display: none;" :value="currentSelectFont.value" :label="currentSelectFont.label"
                 :title="currentSelectFont.label"></el-option>
    </el-select>
  </div>
</template>

<script>
import i18n from '../../language/index'

const LANG_ZH = 'en'
export default {
  name: "my_font_family",
  props: {
    title: { // 组件的标题
      type: String,
      default: ''
    },
    type: { // 组件的类型  one_level 一级组件 two_level 二级组件
      type: String,
      default: 'two_level'
    },
    value: { // 输入框的值
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isGroup: {
      type: Boolean,
      default: false
    },
    options: { // 数组
      type: Array,
      default: function () {
        return []
      }
    },
    width: {
      type: String,
      default: '118'
    },
    titleWidth: {
      type: String,
      default: '40'
    }

  },
  data() {
    return {
      font: this.value,
      lang: LANG_ZH,
      fontFamilyHistory: [],
    }
  },
  computed: {
    fontFamilySystem() {
      return this.lang === LANG_ZH ? this.$store.state.options.fontFamilySystemEn : this.$store.state.options.fontFamilySystemZh
    },
    fontFamilyFree() {
      return this.$store.state.options.fontFamilyFree.filter(item => {
        return item.lang === this.lang
      })
    },
    currentSelectFont() {
      let fontList = [...this.$store.state.options.fontFamilySystemZh, ...this.$store.state.options.fontFamilySystemEn, ...this.$store.state.options.fontFamilyFree]
      let font = fontList.find(f => String(f.value) === String(this.value) || String(f.label) === String(this.value))  //有一个很不正常的数据，this.value是'微软雅黑'，不知道怎么弄出来的
      return font
    }
  },
  watch: {
    font(val) {
      this.$refs.selector._data.visible = true
      this.$emit('update:value', val);//双向数据绑定
    },
    value(val) {
      this.font = this.value
    },
  },
  methods: {
    onClickLanguage(lang) {
      console.log(lang)
      this.lang = lang
    },
    onSelectFont(fontValue) {
      console.log('this.font:', this.font)
      let fontList = [...this.$store.state.options.fontFamilySystemZh, ...this.$store.state.options.fontFamilySystemEn, ...this.$store.state.options.fontFamilyFree]
      let font = fontList.find(f => String(f.value) === String(fontValue))
      this.fontFamilyHistory.unshift(font)
      let fontNameList = this.fontFamilyHistory.map(font => font.value)
      fontNameList = [...new Set(fontNameList)]
      this.fontFamilyHistory = fontNameList.map(name => {
        return fontList.find(item => item.value === name)
      })
      if (this.fontFamilyHistory.length > 4) {
        this.fontFamilyHistory.pop()
      }
      localStorage.setItem('fontFamilyHistory', JSON.stringify(this.fontFamilyHistory))
    },
  },
  created() {
    if (!this.font) {
      this.font = 'Arial'
    }
    let fontFamilyHistory = localStorage.getItem('fontFamilyHistory')
    console.log('fontFamilyHistory:', fontFamilyHistory)
    if (fontFamilyHistory) {
      this.fontFamilyHistory = JSON.parse(fontFamilyHistory)
      this.fontFamilyHistory = this.fontFamilyHistory.filter(item => {return item != null})
      this.fontFamilyHistory.map(e => parseInt(e.value) > 12)
    }
  }
}
</script>

<style scoped lang="scss">
@import "src/css/components/special_fonts";
.yang-font-selector {
  margin-bottom: 12px;
  font-size: 0;
}

.font-label {
  display: inline-block;
  color: #303133;
  font-size: 13px;
  margin-right: 8px;
}

.lang-group {
  display: flex;
  position: absolute;
  width: 100%;
  background: #f6f6f6;
  height: 35px;
  z-index: 1;

  .lang-item {
    flex: 1;
    text-align: center;
    border-bottom: 1px solid #eee;
    position: relative;
    padding-top: 5px;
    padding-bottom: 5px;
    font-size: 14px;
    cursor: pointer;
  }

  .lang-item-active {
    color: #0078d7;
  }

  .lang-item-active:after {
    content: '';
    position: absolute;
    width: 2em;
    height: 2px;
    background: #0078d7;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
  }
}

.lang-group-placeholder {
  height: 35px;
}

</style>
<style lang="scss">
.font-family-popper {
  width: 200px;

  .el-select-dropdown__wrap {
    max-height: 370px;
  }

  .el-select-dropdown__list {
    padding-top: 0;
  }

  &.el-select-dropdown.el-popper .popper__arrow::after {
    border-bottom-color: #f6f6f6;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/my_font_family/index.vue